module.exports = require("instafeed.js");


//////////////////
// WEBPACK FOOTER
// external "instafeed.js"
// module id = 261
// module chunks = 0